import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_STATE } from "./apiRoutes";

interface UseGetStateProps {
  countryCode?: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getState = async (countryCode: string = "usa") =>
  await axiosAuth.get(
    `${GET_STATE}/by-country-code/${countryCode?.toUpperCase()}`
  );

const useGetState = ({
  countryCode,
  queryParams,
}: UseGetStateProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["state"],
    queryFn: () => getState(countryCode),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: queryParams?.enabled,
  });
};

export default useGetState;
